export default "__VITE_ASSET__6r5lK6XZ__"